import './Rapor.scss'
import { Dialog } from 'primereact/dialog'
import { TabView, TabPanel } from 'primereact/tabview';
import { useEffect, useState } from 'react';
import { setShowRapor } from '../../features/toolbarSlice';
import { useAppDispatch } from '../../store/hooks'
import RaporPanel from './RaporPanel';
import BolgeRapor from './BolgeRapor';
import IlRapor from './IlRapor';
import OSBRapor from './OSBRapor';
import ParselRapor from './ParselRapor';

export default function Rapor() {
    const dispatch = useAppDispatch();
    const [showpanel, setshowpanel] = useState(false)
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        setshowpanel(true);
    }, [])

    return (
        <Dialog className={`${activeIndex !== 4 ? 'rapor-dialog' : 'rapor-dialog2'}`} header="Raporlar" visible={showpanel} onHide={() => dispatch(setShowRapor(false))}>
            <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                <TabPanel header="Gösterge Paneli">
                    <RaporPanel />
                </TabPanel>
                <TabPanel header="Bölge Raporlama">
                    <BolgeRapor />
                </TabPanel>
                <TabPanel header="İl Raporlama">
                    <IlRapor />
                </TabPanel>
                <TabPanel header="OSB Raporlama">
                    <OSBRapor />
                </TabPanel>
                <TabPanel header="Parsel Aşaması Raporlama">
                    <ParselRapor />
                </TabPanel>
            </TabView>
        </Dialog>
    )
}
